import { useMutation, useQuery } from "@tanstack/react-query";

import queryClient from "@/core/queryClient";

import api from "../core/api";

export const useTargets = (
  venueUuid: string | undefined,
  climbType: "BOULDER" | "SPORT" | undefined,
) =>
  useQuery({
    queryKey: ["venues", venueUuid, "targets", climbType],
    enabled: !!venueUuid && !!climbType,
    queryFn: () => api.routes.getRoutesTargets(venueUuid!, climbType!),
  });

export const useUpdateTargetsMutation = (venueUuid: string | undefined) => {
  return useMutation({
    mutationFn: api.routes.updateRoutesTargets,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["venues", venueUuid, "targets", "BOULDER"],
      });
      queryClient.invalidateQueries({
        queryKey: ["venues", venueUuid, "targets", "SPORT"],
      });
    },
  });
};

export const useGenerateTargetsMutation = (venueUuid: string | undefined) => {
  return useMutation({
    mutationFn: ({
      climbType,
      venueUuid,
      mode,
    }: {
      climbType: "BOULDER" | "SPORT";
      venueUuid: string;
      mode: "GLOBAL" | "BY_ZONE" | "BY_ASCENT_STYLE";
    }) => {
      return api.routes.generateRoutesTargets(venueUuid, climbType, mode);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["venues", venueUuid, "targets", "BOULDER"],
      });
      queryClient.invalidateQueries({
        queryKey: ["venues", venueUuid, "targets", "SPORT"],
      });
    },
  });
};
